module.exports = __webpack_public_path__ + "b49387bcb621970455648a27c549a27e.pdf";